import useUserData from 'hooks/useUserData';
import munIds from './constants';
import React, { ReactNode, useContext, useEffect, useState } from 'react';
import { getMiniSurveysData, setMiniSurveysData } from './MiniSurveyStorage';

export interface SurveysContextProps {
  questions: ReactNode[] | null;
  surveyId: string | null;
}

const defaultContext: SurveysContextProps = {
  questions: null,
  surveyId: null,
};

const Context = React.createContext<SurveysContextProps>(defaultContext);

const MiniSurveyContext = (props: React.PropsWithChildren<{}>) => {
  const [questions, setQuestions] = useState<ReactNode[]>([]);
  const [surveyId, setSurveysId] = useState<string | null>(null);
  const userData = useUserData();

  useEffect(() => {
    if (!userData) return;
    if (!munIds.includes(userData.id)) return;
    const data = getMiniSurveysData('portfolio');
    if (data.isDone) return;
    setSurveysId('portfolio');
    setQuestions([
      'Удалось ли вам передать школам благодарственные письма из раздела Портфолио? Вручить лично или отправить по электронной почте.',
    ]);
  }, [userData]);

  return (
    <Context.Provider
      value={{
        questions,
        surveyId,
      }}
    >
      {props.children}
    </Context.Provider>
  );
};

export const useMiniSurveyContext = () => useContext(Context);

export default MiniSurveyContext;
